import { defineStore } from 'pinia'

import { createNotesActions } from './actions'
import { createNotesState } from './state'

export const useNotesStore = defineStore('notes', () => {
    const state = createNotesState()
    const actions = createNotesActions(state)

    return {
        ...state,
        ...actions
    }
})
